import Transactions from '../components/transactions'
import { Container, Alert } from 'react-bootstrap'
import { useWebSocket } from '../src/contexts/WebSocketContext'

const MainPage = ({ apikey, error }) => {
  const {
    transactions,
    connectionState,
    validate,
    toggleOwnership,
    requestArticles,
    changeArticle,
    clearArticles,
    availableArticles
  } = useWebSocket()

  return (
    <>
      {/* Disconnected state - waiting for reconnection attempt */}
      {connectionState === 'disconnected' && (
        <Container fluid='xl' className='mt-4'>
          <Alert variant='warning'>Connexion perdue, reconnexion...</Alert>
        </Container>
      )}

      {/* Connecting state - actively trying to connect */}
      {connectionState === 'connecting' && (
        <Container fluid='xl' className='mt-4'>
          <Alert variant='info'>Essai de connexion...</Alert>
        </Container>
      )}

      {/* Error state */}
      {error && (
        <Container fluid='xl' className='mt-4'>
          <Alert variant='danger'>{error}</Alert>
        </Container>
      )}

      {/* Transactions list */}
      <Container fluid='xl'>
        <Transactions
          transactions={transactions}
          onToggleOwnership={toggleOwnership}
          onValidate={validate}
          onRequestArticles={requestArticles}
          onChangeArticle={changeArticle}
          onClearArticles={clearArticles}
          availableArticles={availableArticles}
          disabled={connectionState !== 'connected'}
        />
      </Container>
    </>
  )
}

export default MainPage
